import Menu, {
  MenuList,
  MenuListItem,
  MenuListDivider,
  MenuListGroup,
  MenuListGroupSubheader,
  MenuListItemGraphic,
  MenuListItemMeta,
  MenuListItemText,
} from '@material/react-menu';
import './Menu.scss';

/**
 * Menu MCWR Component
 *
 * @version ./package.json
 */
export default Menu;

export {
  MenuList,
  MenuListItem,
  MenuListDivider,
  MenuListGroup,
  MenuListGroupSubheader,
  MenuListItemGraphic,
  MenuListItemMeta,
  MenuListItemText,
};
